import { DialogContent } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";

const AssignmentCompletedDialog = ({ onClose }: any) => {
  const isAssignmentSuccessful = useAppSelector((state) => state.PlanAssignment.isAssignmentSuccessful);

  return (
    <DialogFormation
      openDialog={isAssignmentSuccessful}
      handleClose={onClose}
      title="Plan Assigned"
      actionConfig={
        <div className="modal-config-wrapper">
          <Button label="Close" onClick={onClose} />
        </div>
      }
    >
      <DialogContent>
        <div>
          <div>
            <Typography variant="body1" sx={{ color: tokens.Text.General.PrimaryBody, textAlign: "center" }}>
              {messages.assignPlanConfirmation}
            </Typography>
          </div>
        </div>
      </DialogContent>
    </DialogFormation>
  );
};

export default AssignmentCompletedDialog;
